// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Date divider with horizontal lines left and right, centered text */
.edit-history-date-divider {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  margin: 32px 0 16px 0;
}
.edit-history-date-divider::before,
.edit-history-date-divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #333;
  margin: 0 16px;
  opacity: 0.25;
}
`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/EditHistory.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,OAAO;EACP,6BAA6B;EAC7B,cAAc;EACd,aAAa;AACf","sourcesContent":["/* Date divider with horizontal lines left and right, centered text */\n.edit-history-date-divider {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  font-size: 15px;\n  font-weight: 500;\n  margin: 32px 0 16px 0;\n}\n.edit-history-date-divider::before,\n.edit-history-date-divider::after {\n  content: '';\n  flex: 1;\n  border-bottom: 1px solid #333;\n  margin: 0 16px;\n  opacity: 0.25;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
